import {getAttrMarkup, IBuildTaskDef, register } from "@wm/transpiler";

const tagName = 'div';
register('wm-linearlayoutitem', (): IBuildTaskDef => {
    return {
        pre: attrs => `<${tagName} wmLinearLayoutitem wm-droppable="true" wmsTransclude ${getAttrMarkup(attrs)}>`,
        post: () => `</${tagName}>`
    };
});

export default () => {};
